module.exports = __webpack_public_path__ + "media/icons/spa-f2b57de64b36c0c79dbee7624f5966b5.svg";